var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoneAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28571 2C5.53853 2 6.55594 3.00793 6.57125 4.25712L13.5856 5.73792C13.9187 4.88775 14.7463 4.2857 15.7146 4.2857C16.9769 4.2857 18.0003 5.30905 18.0003 6.57142C18.0003 7.66202 17.2365 8.57422 16.2146 8.80227V13.4834C17.2365 13.7115 18.0003 14.6237 18.0003 15.7143C18.0003 16.9767 16.9769 18 15.7146 18C14.6239 18 13.7117 17.2362 13.4837 16.2143H6.51658C6.28855 17.2362 5.37634 18 4.28571 18C3.02335 18 2 16.9767 2 15.7143C2 14.6236 2.76399 13.7113 3.78603 13.4834V6.51664C2.76399 6.28873 2 5.37644 2 4.28571C2 3.02335 3.02335 2 4.28571 2ZM15.2146 13.4834C14.3536 13.6755 13.6758 14.3533 13.4837 15.2143H6.51657C6.32446 14.3534 5.64683 13.6757 4.78603 13.4835V6.5165C5.49019 6.35926 6.07177 5.87715 6.36528 5.23568L13.4341 6.72799C13.5032 7.74848 14.242 8.58527 15.2146 8.80228V13.4834Z",
    fill: "#5EA2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneAdd);
export default __webpack_public_path__ + "static/media/zone-add.664ff290d1247a41868b88c09bde803c.svg";
export { ForwardRef as ReactComponent };